export default function AnchorProblemClass() { 
    this.maxTension = 1e20, 
    this.tensionCapacityMessage = "", 
    this.phiTensionSteel = 0, 
    this.phiNsa = 0, 
    this.phiTensionConcreteBreakOut = 0, 
    this.Anc = 0, 
    this.Anco = 0, 
    this.PsiedN = 0, 
    this.Nb = 0, 
    this.Hef_ConcBreakout = 0, 
    this.ncb = 0, 
    this.kc = 24, 
    this.phiPullout = 0, 
    this.Np = 0, 
    this.Npn = 0, 
    this.sideFaceBlowOutApplies = !1, 
    this.phiSideFace = 0, 
    this.Ca1SideFace = 0, 
    this.Nsb = 0, 
    this.maxShearX = 1e20, 
    this.maxShearY = 1e20, 
    this.shearXCapacityMessage = "", 
    this.shearYCapacityMessage = "", 
    this.phiVxSteel = 0, 
    this.phiVySteel = 0, 
    this.vsaX = 0, 
    this.vsaY = 0, 
    this.phiShearXBreakout = 0, 
    this.phiShearYBreakout = 0, 
    this.ca1ShearX = 0, 
    this.ca1ShearY = 0, 
    this.avcShearX = 0, 
    this.avcShearY = 0, 
    this.avcoShearX = 0, 
    this.avcoShearY = 0, 
    this.psiEdvShearX = 0, 
    this.psiEdvShearY = 0, 
    this.psiCvShearX = 0, 
    this.psiCvShearY = 0, 
    this.psiHvShearX = 0, 
    this.psiHvShearY = 0, 
    this.VbShearX = 0, 
    this.VbShearY = 0, 
    this.vcbX = 0, 
    this.vcbY = 0, 
    this.phiPryoutShearX = 0, 
    this.phiPryoutShearY = 0, 
    this.kcpShearX = 0, 
    this.kcpShearY = 0, 
    this.vcpX = 0, 
    this.vcpY = 0, 
    this.interactionX = 0, 
    this.interactionY = 0 
} 

AnchorProblemClass.prototype.CalculateTensionCapacity = function (oAnchorDesign, oLoad, oBolt, oGeometry, oConcrete) { 
    this.maxTension = 1e20; 
    for (var i = 0; 2 > i; i++) { 
        var btc = this.BoltTensionCapacity(oAnchorDesign, oLoad, oBolt, oGeometry); 
        btc < this.maxTension && (this.maxTension = btc, this.tensionCapacityMessage = "Bolt Tension Controls"); 
        var cbtc = this.ConcreteBreakoutTensionCapacity(oAnchorDesign, oLoad, oBolt, oGeometry, oConcrete); 
        cbtc < this.maxTension && (this.maxTension = cbtc, this.tensionCapacityMessage = "Breakout Controls"); 
        var cpc = this.ConcretePulloutCapacity(oAnchorDesign, oLoad, oBolt, oGeometry, oConcrete); 
        cpc < this.maxTension && (this.maxTension = cpc, this.tensionCapacityMessage = "Pullout Controls"); 
        var csfbc = this.ConcreteSideFaceBlowoutCapacity(oAnchorDesign, oLoad, oBolt, oGeometry, oConcrete); 
        csfbc < this.maxTension && (this.maxTension = csfbc, this.tensionCapacityMessage = "Blowout Controls") 
    } 
    return this.maxTension 
}, 

AnchorProblemClass.prototype.BoltTensionCapacity = function (oAnchorDesign, oLoad, oBolt, oGeometry) { 
    return this.phiTensionSteel = oAnchorDesign.GetPhiFactor(0, 0, oLoad.Chapter9()), 
    this.phiNsa = oAnchorDesign.Nsa(oBolt, oGeometry) * this.phiTensionSteel, 
    this.phiNsa 
}, 
AnchorProblemClass.prototype.ConcreteBreakoutTensionCapacity = function (oAnchorDesign, oLoad, oBolt, oGeometry, oConcrete) { 
    this.phiTensionConcreteBreakOut = oAnchorDesign.GetPhiFactor(3, oAnchorDesign.Condition(oConcrete), oLoad.Chapter9()); 
    var seismicFactor = oAnchorDesign.SeismicFactor(oLoad.categoryCOrHigher); 
    return this.Anc = oAnchorDesign.Anc(oGeometry, oBolt), 
    this.Anco = oAnchorDesign.Anco(oGeometry, oBolt), 
    this.PsiedN = oAnchorDesign.EdgeEffectTensionFactor(oGeometry, oBolt), 
    this.Nb = oAnchorDesign.Nb(oGeometry, oBolt, oConcrete.fc), 
    this.Hef_ConcBreakout = oAnchorDesign.EffectiveEmbed(oGeometry, oBolt), 
    this.ncb = oAnchorDesign.Ncb(oGeometry, oBolt, oConcrete.fc) * this.phiTensionConcreteBreakOut * seismicFactor, 
    oConcrete.barsPreventTensionBreakout && (this.ncb = 1e20), 
    this.ncb 
}, 
AnchorProblemClass.prototype.ConcretePulloutCapacity = function (oAnchorDesign, oLoad, oBolt, oGeometry, oConcrete) { this.phiPullout = oAnchorDesign.GetPhiFactor(3, 1, oLoad.Chapter9()); var seismicFactor = oAnchorDesign.SeismicFactor(oLoad.categoryCOrHigher); return this.Np = oAnchorDesign.Np(oGeometry, oBolt, oConcrete.fc), this.Npn = oAnchorDesign.Npn(oGeometry, oBolt, oConcrete.fc) * this.phiPullout * seismicFactor, this.Npn }, 
AnchorProblemClass.prototype.ConcreteSideFaceBlowoutCapacity = function (oAnchorDesign, oLoad, oBolt, oGeometry, oConcrete) { 
    //this.phiSideFace = oAnchorDesign.GetPhiFactor(3, oAnchorD esign.Condition(oConcrete.barsCrossTensionFailure, oConcrete.barsPreventTensionBreakout), oLoad.Chapter9()); 
    this.phiSideFace = oAnchorDesign.GetPhiFactor(3, oAnchorDesign.Condition(oConcrete), oLoad.Chapter9()); 
    var seismicFactor = oAnchorDesign.SeismicFactor(oLoad.categoryCOrHigher); 
    return this.Ca1SideFace = oGeometry.MinEdge(), 
    this.sideFaceBlowOutApplies = oAnchorDesign.considerSideFaceBlowout(oGeometry, oBolt), 
    this.Nsb = oAnchorDesign.Nsbg(oGeometry, oBolt, oConcrete.fc, this.Ca1SideFace) * this.phiSideFace * seismicFactor, 
    this.Nsb 
}, 
AnchorProblemClass.prototype.CalculateShearXCapacity = function (oAnchorDesign, oLoad, oBolt, oGeometry, oConcrete) { 
    this.maxShearX = 1e20; 
    for (var i = 0; 2 > i; ++i) { 
        var bsc = this.BoltShearCapacityX(oAnchorDesign, oLoad, oBolt, oGeometry); 
        bsc < this.maxShearX && (this.maxShearX = bsc, this.shearXCapacityMessage = "Bolt Shear Controls"); 
        var cbsc = this.ConcreteBreakoutShearCapacityX(oAnchorDesign, oLoad, oBolt, oGeometry, oConcrete); 
        cbsc < this.maxShearX && (this.maxShearX = cbsc, this.shearXCapacityMessage = "Breakout Controls"); 
        var cpc = this.ConcretePryoutCapacityX(oAnchorDesign, oLoad, oBolt, oGeometry, oConcrete); 
        cpc < this.maxShearX && (this.maxShearX = cpc, this.shearXCapacityMessage = "Pryout Controls") 
    } 
    return this.maxShearX 
}, 
AnchorProblemClass.prototype.BoltShearCapacityX = function (oAnchorDesign, oLoad, oBolt, oGeometry) { 
    return this.phiVxSteel = oAnchorDesign.GetPhiFactor(1, 0, oLoad.Chapter9()), 
    this.vsaX = oAnchorDesign.Vsa(oBolt, oGeometry) * this.phiVxSteel, this.vsaX 
}, 
AnchorProblemClass.prototype.ConcreteBreakoutShearCapacityX = function (oAnchorDesign, oLoad, oBolt, oGeometry, oConcrete) { 
    this.phiShearXBreakout = oAnchorDesign.GetPhiFactor(2, oAnchorDesign.Condition(oConcrete), oLoad.Chapter9()); 
    //this.phiShearXBreakout = oAnchorDesign.GetPhiFactor(2, oAnchorDesign.Condition(oConcrete.shearXStirrups, oConcrete.shearXNoBreakout), oLoad.Chapter9()); 
    var seismicFactor = oAnchorDesign.SeismicFactor(oLoad.categoryCOrHigher); 
    return this.ca1ShearX = oAnchorDesign.Ca1_Vx(oBolt, oGeometry, oLoad, oConcrete), 
    this.vcbX = oAnchorDesign.Vcb_X(oBolt, oGeometry, oLoad, oConcrete) * this.phiShearXBreakout * seismicFactor, 
    this.avcShearX = oAnchorDesign.Avc_X(oGeometry, this.ca1ShearX, oConcrete.thickness), 
    this.avcoShearX = oAnchorDesign.Avco(this.ca1ShearX), 
    this.psiEdvShearX = oAnchorDesign.EdgeShearFactor(this.ca1ShearX, oAnchorDesign.Ca2_Vx(oGeometry)), 
    this.psiCvShearX = oAnchorDesign.CrackedConcShearFactor(oConcrete.shearXNoBreakout, oConcrete.shearXNumber4Bars, oConcrete.shearXStirrups), 
    this.psiHvShearX = oAnchorDesign.ConcreteThicknessFactor(this.ca1ShearX, oConcrete.thickness), 
    this.VbShearX = oAnchorDesign.Vb(oBolt, this.ca1ShearX, oConcrete.fc), 
    this.vcbX 
}, 
AnchorProblemClass.prototype.ConcretePryoutCapacityX = function (oAnchorDesign, oLoad, oBolt, oGeometry, oConcrete) { 
    this.phiPryoutShearX = oAnchorDesign.GetPhiFactor(2, 1, oLoad.Chapter9()); 
    var seismicFactor = oAnchorDesign.SeismicFactor(oLoad.categoryCOrHigher); 
    return this.kcpShearX = oAnchorDesign.Kcp(oBolt), 
    this.vcpX = oAnchorDesign.Vcp(oGeometry, oBolt, oConcrete.fc) * this.phiPryoutShearX * seismicFactor, 
    this.vcpX 
}, 
AnchorProblemClass.prototype.CalculateShearYCapacity = function (oAnchorDesign, oLoad, oBolt, oGeometry, oConcrete) { 
    this.maxShearY = 1e20; 
    for (var i = 0; 2 > i; ++i) { 
        var bsc = this.BoltShearCapacityY(oAnchorDesign, oLoad, oBolt, oGeometry); 
        bsc < this.maxShearY && (this.maxShearY = bsc, this.shearYCapacityMessage = "Bolt Shear Controls"); 
        var cbsc = this.ConcreteBreakoutShearCapacityY(oAnchorDesign, oLoad, oBolt, oGeometry, oConcrete); 
        cbsc < this.maxShearY && (this.maxShearY = cbsc, this.shearYCapacityMessage = "Breakout Controls"); 
        var cpc = this.ConcretePryoutCapacityY(oAnchorDesign, oLoad, oBolt, oGeometry, oConcrete); 
        cpc < this.maxShearY && (this.maxShearY = cpc, this.shearYCapacityMessage = "Pryout Controls") 
    } 
    return this.maxShearY 
}, 
AnchorProblemClass.prototype.BoltShearCapacityY = function (oAnchorDesign, oLoad, oBolt, oGeometry) { 
    return this.phiVySteel = oAnchorDesign.GetPhiFactor(1, 0, oLoad.Chapter9()), 
    this.vsaY = oAnchorDesign.Vsa(oBolt, oGeometry) * this.phiVySteel, 
    this.vsaY 
}, 
AnchorProblemClass.prototype.ConcreteBreakoutShearCapacityY = function (oAnchorDesign, oLoad, oBolt, oGeometry, oConcrete) { 
    this.phiShearYBreakout = oAnchorDesign.GetPhiFactor(2, oAnchorDesign.Condition(oConcrete), oLoad.Chapter9());
    //this.phiShearYBreakout = oAnchorDesign.GetPhiFactor(2, oAnchorDesign.Condition(oConcrete.shearYStirrups, oConcrete.shearYNoBreakout), oLoad.Chapter9());
    var seismicFactor = oAnchorDesign.SeismicFactor(oLoad.categoryCOrHigher); 
    return this.ca1ShearY = oAnchorDesign.Ca1_Vy(oBolt, oGeometry, oLoad, oConcrete), 
    this.vcbY = oAnchorDesign.Vcb_Y(oBolt, oGeometry, oLoad, oConcrete) * this.phiShearYBreakout * seismicFactor, 
    this.avcShearY = oAnchorDesign.Avc_Y(oGeometry, this.ca1ShearY, oConcrete.thickness), 
    this.avcoShearY = oAnchorDesign.Avco(this.ca1ShearY), 
    this.psiEdvShearY = oAnchorDesign.EdgeShearFactor(this.ca1ShearY, oAnchorDesign.Ca2_Vy(oGeometry)), 
    this.psiCvShearY = oAnchorDesign.CrackedConcShearFactor(oConcrete.shearYNoBreakout, oConcrete.shearYNumber4Bars, oConcrete.shearYStirrups), 
    this.psiHvShearY = oAnchorDesign.ConcreteThicknessFactor(this.ca1ShearY, oConcrete.thickness), 
    this.VbShearY = oAnchorDesign.Vb(oBolt, this.ca1ShearY, oConcrete.fc), 
    this.vcbY 
}, 
AnchorProblemClass.prototype.ConcretePryoutCapacityY = function (oAnchorDesign, oLoad, oBolt, oGeometry, oConcrete) { 
    this.phiPryoutShearY = oAnchorDesign.GetPhiFactor(2, 1, oLoad.Chapter9()); 
    var seismicFactor = oAnchorDesign.SeismicFactor(oLoad.categoryCOrHigher); 
    return this.kcpShearY = oAnchorDesign.Kcp(oBolt), 
    this.vcpY = oAnchorDesign.Vcp(oGeometry, oBolt, oConcrete.fc) * this.phiPryoutShearY * seismicFactor, 
    this.vcpY 
}, 
AnchorProblemClass.prototype.CalculateInteractionValueX = function (oAnchorDesign, oLoad) { 
    return this.interactionX = oAnchorDesign.InteractionCheck(oLoad.vX, this.maxShearX, oLoad.nZ, this.maxTension), 
    this.interactionX 
}, 
AnchorProblemClass.prototype.CalculateInteractionValueY = function (oAnchorDesign, oLoad) { 
    return this.interactionY = oAnchorDesign.InteractionCheck(oLoad.vY, this.maxShearY, oLoad.nZ, this.maxTension), 
    this.interactionY 
};